export default "__VITE_ASSET__CMuXEv7z__"